<template>
  <div
    class="chat-session"
    @click="selectSession"
    :class="sessionData._id === selectedSession._id ? 'selected-session' : ''"
  >
    <div class="chat-session--header">
      <div class="platform-icon">
        <supported-platforms
          class="supported-platforms-list"
          :placeholder="null"
          :manual-channels="[
            sessionData.channel.name.toLowerCase().replace(' ', '-'),
          ]"
        />
      </div>

      <div class="session-info">
        <div class="d-flex align-center justify-space-between">
          <div class="session-id">{{ sessionData.user_display_name }}</div>
          <div class="session-timestamp text-xs-right">
            <p>{{ common.timeAgo(sessionData.updated_at) }}</p>
          </div>
        </div>
        <div class="session-summary">
          <p>
            {{
              sessionData.last_message.payload ||
              sessionData.last_message.mediaUrl ||
              sessionData.last_message.slug ||
              (sessionData.last_message.text.body
                ? sessionData.last_message.text.body
                : sessionData.last_message.text)
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import common from "../../../utils/common";
import SupportedPlatforms from "../../block-build/blocks/SupportedPlatforms.vue";
export default {
  props: {
    sessionData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectedSession: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    SupportedPlatforms,
  },
  data() {
    return {
      common,
      sessionId: null,
      currentSessionId: name,
      iconsPresets: {
        whatsapp: {
          class: "white--text green accent-4 botter-whatsapp-icon",
        },
        messenger: {
          class: "white--text blue botter-messenger-icon",
        },
        facebook: {
          class: "white--text blue botter-messenger-icon",
        },
        twitter: {
          class: "white--text blue lighten-2 botter-twitter-filled-icon",
        },
        web: {
          class: "white--text amber botter-web-icon",
        },
        "mobile-android": {
          class: "white--text purple botter-phone-icon",
        },
        "mobile-ios": {
          class: "white--text purple botter-phone-icon",
        },
      },
    };
  },
  computed: {},

  mounted() {},
  methods: {
    selectSession() {
      if (this.sessionData._id !== this.selectedSession._id) {
        this.$emit("selectSession", this.sessionData);
      }
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.full-width {
  width: 100%;
}
</style>
